import { useLocalZonePreference } from '@/hooks/useLocalZonePreference';
import { MetricConfig } from '@/types/evals';
import { formatTimestamp } from '@/utils/timeFormatter';

import { InfoCard } from '../../_components/InfoCard';
import { InfoCardRow } from '../../_components/InfoCardRow';

type Props = {
  config: MetricConfig;
};

export function MetricFooterRow( { config }: Props ) {
  const [ useLocalZone ] = useLocalZonePreference();

  return (
    <InfoCardRow data-testid="metric-footer-row">
      <InfoCard label="Version Created" value={ formatTimestamp( config.createdAt, useLocalZone ) } />
      <InfoCard label="Version Updated" value={ formatTimestamp( config.updatedAt, useLocalZone ) } />
      <InfoCard label="Version Created By" value={ config.createdBy ?? '—' } />
      <InfoCard label="Deprecated" value={ config.isDeprecated ? 'true' : 'false' } />
    </InfoCardRow>
  );
}
